import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';

import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';

import { HeroModule } from 'src/app/shared/components/hero/hero.module';
import { DialogAlertModule } from 'src/app/shared/components/dialog-alert/dialog-alert.module';
import { LoadingModule } from 'src/app/shared/components/loading/loading.module';

import { AlertModule } from 'src/app/shared/components/alert/alert.module';
import { CartModule } from 'src/app/shared/components/cart/cart.module';
import { ProductChoiceModule } from 'src/app/shared/components/product-choice/product-choice.module';


import { CartService } from 'src/app/shared/services/cart.service';
import { LocationService } from 'src/app/shared/services/location.service';

import { CheckoutIdentificationComponent } from './identification.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    
    NgxMaskDirective,
    MatBottomSheetModule,
    MatButtonModule,
    MatCardModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    AlertModule,
    HeroModule,
    DialogAlertModule,
    LoadingModule,
    CartModule,
    ProductChoiceModule,
    MatTabsModule
  ],
  exports: [
    CheckoutIdentificationComponent
  ],
  providers: [
    CartService,
    LocationService,
    provideNgxMask()
  ],
  declarations: [
    CheckoutIdentificationComponent
  ]
})
export class CheckoutIdentificationModule { }
